/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum FeedEventType {
  COMMENT = "COMMENT",
  CREATE = "CREATE",
  EDIT = "EDIT",
  EDITLIVE = "EDITLIVE",
  PUBLISH = "PUBLISH",
  PUBLISHLIVE = "PUBLISHLIVE",
  SNAPSHOT = "SNAPSHOT",
  START = "START",
}

export enum FeedItemSourceType {
  PERSON = "PERSON",
  SPACE = "SPACE",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FeedContentQuery
// ====================================================

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_Anonymous_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_Anonymous {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_Anonymous_profilePicture | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_KnownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_KnownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_KnownUser_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_User_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_User {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_User_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_UnknownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_UnknownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_UnknownUser_profilePicture | null;
  accountId: string | null;
}

export type FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user = FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_Anonymous | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_KnownUser | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_User | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user_UnknownUser;

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate {
  datetime: string;
  type: FeedEventType;
  groupSize: number;
  user: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate_user;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_Anonymous_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_Anonymous {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_Anonymous_profilePicture | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_KnownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_KnownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_KnownUser_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_User_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_User {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_User_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_UnknownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_UnknownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_UnknownUser_profilePicture | null;
  accountId: string | null;
}

export type FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user = FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_Anonymous | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_KnownUser | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_User | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user_UnknownUser;

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit {
  datetime: string;
  type: FeedEventType;
  groupSize: number;
  version: number;
  user: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit_user;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_Anonymous_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_Anonymous {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_Anonymous_profilePicture | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_KnownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_KnownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_KnownUser_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_User_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_User {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_User_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_UnknownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_UnknownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_UnknownUser_profilePicture | null;
  accountId: string | null;
}

export type FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user = FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_Anonymous | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_KnownUser | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_User | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user_UnknownUser;

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive {
  datetime: string;
  type: FeedEventType;
  groupSize: number;
  version: number;
  user: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive_user;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_Anonymous_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_Anonymous {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_Anonymous_profilePicture | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_KnownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_KnownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_KnownUser_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_User_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_User {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_User_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_UnknownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_UnknownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_UnknownUser_profilePicture | null;
  accountId: string | null;
}

export type FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user = FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_Anonymous | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_KnownUser | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_User | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user_UnknownUser;

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive {
  datetime: string;
  type: FeedEventType;
  groupSize: number;
  version: number;
  user: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive_user;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_Anonymous_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_Anonymous {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_Anonymous_profilePicture | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_KnownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_KnownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_KnownUser_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_User_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_User {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_User_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_UnknownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_UnknownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_UnknownUser_profilePicture | null;
  accountId: string | null;
}

export type FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user = FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_Anonymous | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_KnownUser | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_User | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user_UnknownUser;

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment_links {
  webui: string | null;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment_location_FooterComment {
  type: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment_location_InlineComment {
  type: string;
  inlineText: string | null;
}

export type FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment_location = FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment_location_FooterComment | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment_location_InlineComment;

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment_body {
  value: string;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment {
  id: string;
  links: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment_links;
  location: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment_location;
  body: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment_body;
}

export interface FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment {
  datetime: string;
  type: FeedEventType;
  groupSize: number;
  user: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_user;
  comment: FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment_comment | null;
}

export type FeedContentQuery_feed_nodes_summaryLineUpdate = FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventCreate | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEdit | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventEditLive | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventPublishLive | FeedContentQuery_feed_nodes_summaryLineUpdate_FeedEventComment;

export interface FeedContentQuery_feed_nodes_content_emoji_nodes {
  id: string | null;
  value: string | null;
}

export interface FeedContentQuery_feed_nodes_content_emoji {
  nodes: (FeedContentQuery_feed_nodes_content_emoji_nodes | null)[] | null;
}

export interface FeedContentQuery_feed_nodes_content_links {
  webui: string | null;
}

export interface FeedContentQuery_feed_nodes_content_history_createdBy_Anonymous_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_content_history_createdBy_Anonymous {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_content_history_createdBy_Anonymous_profilePicture | null;
}

export interface FeedContentQuery_feed_nodes_content_history_createdBy_KnownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_content_history_createdBy_KnownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_content_history_createdBy_KnownUser_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_content_history_createdBy_User_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_content_history_createdBy_User {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_content_history_createdBy_User_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_content_history_createdBy_UnknownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_content_history_createdBy_UnknownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_content_history_createdBy_UnknownUser_profilePicture | null;
  accountId: string | null;
}

export type FeedContentQuery_feed_nodes_content_history_createdBy = FeedContentQuery_feed_nodes_content_history_createdBy_Anonymous | FeedContentQuery_feed_nodes_content_history_createdBy_KnownUser | FeedContentQuery_feed_nodes_content_history_createdBy_User | FeedContentQuery_feed_nodes_content_history_createdBy_UnknownUser;

export interface FeedContentQuery_feed_nodes_content_history_ownedBy_Anonymous_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_content_history_ownedBy_Anonymous {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_content_history_ownedBy_Anonymous_profilePicture | null;
}

export interface FeedContentQuery_feed_nodes_content_history_ownedBy_KnownUser_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_content_history_ownedBy_KnownUser {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_content_history_ownedBy_KnownUser_profilePicture | null;
  accountId: string | null;
}

export interface FeedContentQuery_feed_nodes_content_history_ownedBy_User_profilePicture {
  path: string;
}

export interface FeedContentQuery_feed_nodes_content_history_ownedBy_User {
  type: string | null;
  displayName: string | null;
  profilePicture: FeedContentQuery_feed_nodes_content_history_ownedBy_User_profilePicture | null;
  accountId: string | null;
}

export type FeedContentQuery_feed_nodes_content_history_ownedBy = FeedContentQuery_feed_nodes_content_history_ownedBy_Anonymous | FeedContentQuery_feed_nodes_content_history_ownedBy_KnownUser | FeedContentQuery_feed_nodes_content_history_ownedBy_User;

export interface FeedContentQuery_feed_nodes_content_history {
  createdBy: FeedContentQuery_feed_nodes_content_history_createdBy | null;
  ownedBy: FeedContentQuery_feed_nodes_content_history_ownedBy | null;
  createdDate: string | null;
}

export interface FeedContentQuery_feed_nodes_content_space {
  alias: string | null;
  id: string | null;
  key: string | null;
  name: string | null;
}

export interface FeedContentQuery_feed_nodes_content_metadata_comments {
  commentsCount: number | null;
}

export interface FeedContentQuery_feed_nodes_content_metadata_currentuser_favourited {
  isFavourite: boolean | null;
}

export interface FeedContentQuery_feed_nodes_content_metadata_currentuser {
  favourited: FeedContentQuery_feed_nodes_content_metadata_currentuser_favourited | null;
}

export interface FeedContentQuery_feed_nodes_content_metadata {
  lastModifiedDate: string | null;
  comments: FeedContentQuery_feed_nodes_content_metadata_comments | null;
  currentuser: FeedContentQuery_feed_nodes_content_metadata_currentuser | null;
}

export interface FeedContentQuery_feed_nodes_content {
  title: string | null;
  id: string | null;
  type: string | null;
  subType: string | null;
  emoji: FeedContentQuery_feed_nodes_content_emoji | null;
  excerpt: string;
  links: FeedContentQuery_feed_nodes_content_links | null;
  history: FeedContentQuery_feed_nodes_content_history | null;
  space: FeedContentQuery_feed_nodes_content_space | null;
  metadata: FeedContentQuery_feed_nodes_content_metadata;
}

export interface FeedContentQuery_feed_nodes {
  recentActionsCount: number;
  summaryLineUpdate: FeedContentQuery_feed_nodes_summaryLineUpdate;
  source: FeedItemSourceType[];
  content: FeedContentQuery_feed_nodes_content;
}

export interface FeedContentQuery_feed_pageInfo {
  hasNextPage: boolean;
  endCursor: string;
}

export interface FeedContentQuery_feed {
  nodes: FeedContentQuery_feed_nodes[];
  pageInfo: FeedContentQuery_feed_pageInfo;
}

export interface FeedContentQuery_getFeedUserConfig_spaces {
  id: string | null;
}

export interface FeedContentQuery_getFeedUserConfig_users_Anonymous {}

export interface FeedContentQuery_getFeedUserConfig_users_KnownUser {
  accountId: string | null;
}

export interface FeedContentQuery_getFeedUserConfig_users_User {
  accountId: string | null;
}

export interface FeedContentQuery_getFeedUserConfig_users_UnknownUser {
  accountId: string | null;
}

export type FeedContentQuery_getFeedUserConfig_users = FeedContentQuery_getFeedUserConfig_users_Anonymous | FeedContentQuery_getFeedUserConfig_users_KnownUser | FeedContentQuery_getFeedUserConfig_users_User | FeedContentQuery_getFeedUserConfig_users_UnknownUser;

export interface FeedContentQuery_getFeedUserConfig {
  spaces: (FeedContentQuery_getFeedUserConfig_spaces | null)[] | null;
  users: (FeedContentQuery_getFeedUserConfig_users | null)[] | null;
  servingRecommendations: boolean;
}

export interface FeedContentQuery {
  feed: FeedContentQuery_feed;
  getFeedUserConfig: FeedContentQuery_getFeedUserConfig;
}

export interface FeedContentQueryVariables {
  first?: number | null;
  after?: string | null;
  sortBy?: string | null;
}
